import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SalesPartPriceGroupsPage } from "src/components/views/erp/sales/masterData/salesPartPriceGroups/SalesPartPriceGroupsPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/salesPartPriceGroups")({
	staticData: { title: i18n.t("sales_part_price_groups"), legacyViewKey: "salesPartPriceGroupsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SalesPartPriceGroupsPage />;
}
